import { Link } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";

export default function NotFound() {
  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <SiteHeader />
      <main className="flex-1 flex items-center justify-center px-4 py-24">
        <div className="text-center max-w-[560px]">
          <p className="font-heading text-6xl md:text-7xl font-black text-primary-200 select-none">404</p>
          <h1 className="mt-6 font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            这个瓜，暂时找不到了
          </h1>
          <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-600">
            页面可能已经调整位置，或者链接有误。你可以回到首页，或者去「打榜观察」继续看票数异常与赛制争议。
          </p>
          <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-md text-sm bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-home-4-line" />
              返回首页
            </Link>
            <Link
              to="/ranking"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-md text-sm bg-secondary-100 text-secondary-900 hover:bg-secondary-200 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-radar-line" />
              进入打榜观察
            </Link>
          </div>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}